export enum WellKnownError {
    Unathorized = 0,
    InvalidAccessToken = 1,
    InternalError = 2,
    NoLicense = 8,
    InsufficientPermissions = 15,
    ObjectNotFound = 16,
    NotSupported = 17,
    InvalidData = 20,
    UserNotFound = 22,
}
